import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Toaster } from "react-hot-toast";

import "./index.css";
import { store } from "./redux/store";
import { logout, setTokens } from "./features/auth/authSlice";
import { injectStore } from "./services/api";
import App from "./App";
import theme from "./theme";

injectStore(store, { logout, setTokens });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster position="top-right" />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
